import {getBannerStatLogger} from './BannerStat';

export function getRbSyncData(externalLog?: (message: string, error?: Error) => void) {
    const logger = getBannerStatLogger();
    let data = {};
    ['localStorage', 'sessionStorage']
        .map(name => {
            try {
                return {
                    // @ts-ignore
                    storage: window[name] as Storage,
                    name: name
                };
            } catch (e) {
                // иногда при попытке обращения к localStorage / sessionStorage кидается исключение
                // SecurityError - Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
                const msg = "can not get rb_sync_id from " + name;
                logger.error("getRbSyncData", msg);
                externalLog?.(msg, e as Error);
                return undefined;
            }
        })
        .forEach((storeInfo) => {
            if (storeInfo) {
                const storage = storeInfo.storage;
                try {
                    const ids = storage.getItem('rb_sync_id');
                    if (ids) {
                        data = { ...data, ...JSON.parse(ids) };
                    }
                } catch (e) {
                    const msg = "can not get rb_sync_id from " + storeInfo.name;
                    logger.error("getRbSyncData", msg);
                    externalLog?.(msg, e as Error);
                }
            }
        });

    return data;
}
